// extracted by mini-css-extract-plugin
export default {"_":"ButtonIcon____xt+b3"};